const allergiesList =  [
    "Lait", "Fromage", "Beurre", "Crème", "Yaourt","Œufs",
    "Fruits à coque", "Noix", "Amandes", "Noisettes", "Pistaches", "Noix de cajou", "Noix de pécan", "Noix du Brésil", "Macadamia",
    "Cacahuètes",
    "Poisson", "Fruits de mer", "Crustacés", "Mollusques",
    "Soja", "Lupin", "Sésame",
    "Gluten", "Blé", "Seigle", "Orge", "Avoine", "Épeautre", "Kamut",
    "Sulfites", "Moutarde",
    "Tomates", "Fraises", "Kiwi", "Chocolat", "Agrumes", "Banane", "Cannelle"
  ];

  export default allergiesList;